import React from "react";
import {
  ConfidenceContainer,
  ConfidenceLabel,
  ConfidenceText,
  ConfidenceValue,
  ConfidenceBar,
  ConfidenceFill,
} from "./styles";

interface ConfidenceIndicatorProps {
  confidence: number;
}

export const ConfidenceIndicator: React.FC<ConfidenceIndicatorProps> = ({ confidence }) => {
  const confidenceValue = confidence ?? 0;
  
  return (
    <ConfidenceContainer>
      <ConfidenceLabel>
        <ConfidenceText $confidence={confidenceValue}>
          Confidence
        </ConfidenceText>
        <ConfidenceValue>{confidenceValue}%</ConfidenceValue>
      </ConfidenceLabel>
      <ConfidenceBar>
        <ConfidenceFill $confidence={confidenceValue} />
      </ConfidenceBar>
    </ConfidenceContainer>
  );
};
